import { Page } from "@/components/wizard";
import { Phone, Mail } from "lucide-react";

const rowClass =
  "flex items-center gap-3 px-5 min-h-[56px] rounded-[14px] border border-[#E5E7EB] bg-white shadow-[0_3px_10px_rgba(20,45,67,0.06)] hover:bg-[#F4F6F8] hover:border-[rgba(20,45,67,0.25)] hover:-translate-y-[2px] active:translate-y-[1px] active:shadow-[0_1px_4px_rgba(20,45,67,0.06)] transition-[background-color,border-color,transform,box-shadow] duration-[180ms]";

const WhatsAppIcon = () => (
  <svg viewBox="0 0 24 24" className="w-5 h-5 text-[#142D43] shrink-0" fill="currentColor" aria-hidden="true" data-testid="whatsapp-icon">
    <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413z" />
  </svg>
);

export default function Contatti() {
  return (
    <Page narrow>
      <div data-testid="contatti-page">
        <h1 className="font-display text-3xl sm:text-4xl font-semibold text-[#142D43] tracking-tight">Contatti</h1>
        <div className="mt-8" data-testid="contatti-info">
          <p className="text-base font-semibold text-[#142D43]">Dr. med. Nicolò Pipitone</p>
          <p className="mt-1 text-base text-[#374151]">via Generale Guisan 8B, 6900 Lugano Paradiso</p>
        </div>
        <div className="mt-8 flex flex-col gap-3">
          <a href="tel:+41916471417" data-testid="contatti-phone" className={rowClass}>
            <Phone size={20} strokeWidth={1.5} className="text-[#142D43] shrink-0" />
            <span className="text-base text-[#142D43]">+41 91 647 14 17</span>
          </a>
          <a href="https://wa.me/41797001595" target="_blank" rel="noreferrer" data-testid="contatti-whatsapp" className={rowClass}>
            <WhatsAppIcon />
            <span className="text-base text-[#142D43]">+41 79 700 15 95</span>
          </a>
          <a href="mailto:pipitone@hin.ch" data-testid="contatti-email" className={rowClass}>
            <Mail size={20} strokeWidth={1.5} className="text-[#142D43] shrink-0" />
            <span className="text-base text-[#142D43]">pipitone@hin.ch</span>
          </a>
        </div>
      </div>
    </Page>
  );
}
